import React, { useState } from "react";

const brands = [
  {
    name: "Brand One",
    logo: "https://th.bing.com/th?q=High+Resolution+McDonald%27s+Logo&w=120&h=120&c=1&rs=1&qlt=90&cb=1&dpr=1.6&pid=InlineBlock&mkt=en-IN&cc=IN&setlang=en&adlt=moderate&t=1&mw=247",
    url: "https://mcdelivery.co.in/",
  },
  {
    name: "Brand Two",
    logo: "https://th.bing.com/th/id/OIP.fU1f4Q6Ctp1XJvSGxh7bZQAAAA?w=261&h=180&c=7&r=0&o=5&dpr=1.6&pid=1.7",
    url: "https://mcdelivery.co.in/",
  },
  {
    name: "Brand Three",
    logo: "https://th.bing.com/th/id/OIP.ZbUoM4lxWmGrkkoj3l4BAwHaE8?w=278&h=185&c=7&r=0&o=5&dpr=1.6&pid=1.7",
    url: "https://mcdelivery.co.in/",
  },
  {
    name: "Brand Four",
    logo: "https://th.bing.com/th/id/OIP.z-dCYjfji4dKA8uXYCj7wQAAAA?w=179&h=187&c=7&r=0&o=5&dpr=1.6&pid=1.7",
    url: "https://mcdelivery.co.in/",
  },
  {
    name: "Brand Five",
    logo: "https://th.bing.com/th/id/OIP.Y7jmbgCumfuemuTnXdbK-QHaH_?w=174&h=187&c=7&r=0&o=5&dpr=1.6&pid=1.7",
    url: "https://mcdelivery.co.in/",
  },
  {
    name: "Brand Six",
    logo: "https://th.bing.com/th/id/OIP.9i2kBWV0EWSs-94FIgtYVQHaG_?w=154&h=180&c=7&r=0&o=5&dpr=1.6&pid=1.7",
    url: "https://mcdelivery.co.in/",
  },
];

const Brands = () => {
  const [hoveredBrand, setHoveredBrand] = useState(null);

  const handleBrandClick = (url) => {
    console.log(`Clicked on ${url}`);
    // Add additional handling logic if needed, like redirecting to the URL
  };

  return (
    <div className="my-10 px-8 py-8 bg-primary-300">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-normal font-serif text-white text-center py-8">
          Our Brands & Partnerships
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-8  py-12">
          {brands.map((brand, index) => (
            <a
              key={index}
              href={brand.url}
              target="_blank" // Open link in a new tab
              rel="noopener noreferrer" // Security best practice for opening external links
              className="brand-link"
              onMouseEnter={() => setHoveredBrand(brand)}
              onMouseLeave={() => setHoveredBrand(null)}
              onClick={(e) => {
                e.preventDefault();
                handleBrandClick(brand.url);
              }}
            >
              <div className="w-40 h-40 p-3 bg-white rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-300">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className={`w-full h-full object-contain ${
                    hoveredBrand === brand ? "scale-150" : "scale-100"
                  }`}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Brands;
